import { render } from "./RestaurantDetailLoader.vue?vue&type=template&id=5743474b"
import script from "./RestaurantDetailLoader.vue?vue&type=script&lang=js"
export * from "./RestaurantDetailLoader.vue?vue&type=script&lang=js"

import "./RestaurantDetailLoader.vue?vue&type=style&index=0&id=5743474b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__